module.exports = __webpack_public_path__ + "img/goldOnlineChangeAct.7215956f.png";